import { createBasicAppPaths } from '@lune/common/paths'
import { version as apiVersion } from './api/version'

export const {
  Root,
  LoginApiUrl,
  LoginPage,
  LoginSuccessPage,
  LoginFailedPage,
  Legacy,
  resolve
} = createBasicAppPaths(apiVersion)

export const AliasNew = resolve(Root.root.url.toString(), 'alias/new')
export const AliasMove = resolve(Root.root.url.toString(), 'alias/move')
